<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Customer Groups</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="customerGroupNew()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="customerGroupList"
		[loading]="!customerGroupList"
		[globalFilterFields]="app.keys(customerGroupList)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="name">
					<div class="d-flex w-100">
						Name
						<p-sortIcon field="name"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="name" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th>Design</th>
				<th pSortableColumn="description">
					<div class="d-flex w-100">
						Description
						<p-sortIcon field="description"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="description" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="customerGroupSelected = rec">
				<td>
					{{ rec.name }}
				</td>
				<td>
					{{ rec.design }}
				</td>
				<td class="overflow-wrap">
					{{ rec.description }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-group-setup
	*ngIf="customerGroupSelected"
	[customerGroup]="customerGroupSelected"
	[venueKey]="venueService.subscriptionVenue.value.key"
	(onSave)="groupSave($event)"
	(onClear)="customerGroupSelected = undefined"
	(onDelete)="groupDelete($event)"
></app-group-setup>
